(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("kRf7T", function(module, exports) {

var $kWqGi = parcelRequire("kWqGi");
const $f2f47da188fe8126$var$items = document.querySelectorAll(".js-service-setter");
$f2f47da188fe8126$var$items.forEach((item)=>{
    const href = item.getAttribute("href");
    const value = item.getAttribute("data-service");
    const selector = `${href} .f-single-select__select`;
    if (!(0, $kWqGi.validateQuery)(selector)) return;
    const select = document.querySelector(selector);
    if (!href || !value || !select) return;
    item.addEventListener("click", ()=>{
        if (select.slim) select.slim.setSelected(value);
        else select.value = value;
    });
});

});
parcelRegister("kWqGi", function(module, exports) {

$parcel$export(module.exports, "validateQuery", function () { return $f3edebc483f39217$export$6d4016d301bc6e21; });
function $f3edebc483f39217$export$6d4016d301bc6e21(selector) {
    try {
        document.querySelector(selector);
        return true;
    } catch (e) {
    // something here to check WHY it's invalid
    }
    return false;
}

});


})();
//# sourceMappingURL=contact-form-section.24e7827c.js.map
